import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/middleware/common/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UpdatePasswordVM } from 'src/app/viewModels/updatePassword/update-password-vm';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';

@Component({
  selector: 'app-update-forgot-password',
  templateUrl: './update-forgot-password.component.html',
  styleUrls: ['./update-forgot-password.component.scss']
})
export class UpdateForgotPasswordComponent implements OnInit {


  constructor(private _formBuilder: FormBuilder, private commonService: CommonService,
    private activatedRoute: ActivatedRoute, private updatePasswordVm: UpdatePasswordVM,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConstant: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private router: Router, private customValidator: CustomvalidationService,) { 
      this.activatedRoute.queryParams.subscribe(params => {
        if (params.Email != undefined && params.Email != null) {
          this.updatePasswordVm.email = params.Email;
          this.updatePasswordVm.token = params.Token;
        }
      });

    }

  updatePasswordForm: FormGroup;
  hidenew = true;
  hideconfirm = true;
  updatePasswordResponseHolder: any;
  UpdatePassword:boolean=false;

  ngOnInit(): void {
    this.updatePasswordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
      confirmPassword: ['', [Validators.required, this.customValidator.checkPassword.bind(this.customValidator)]],
    });
  }

  // To match password on confirm password input box
  Passwords(): void { 
    var newPassword= this.updatePasswordForm.controls['newPassword'].value.length;
    var confirmPassword= this.updatePasswordForm.controls['confirmPassword'].value.length;
    if(newPassword >= 8 && confirmPassword >= 8){
     if (this.updatePasswordForm.controls['newPassword'].value !== this.updatePasswordForm.controls['confirmPassword'].value) {
       this.UpdatePassword=false;
      // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });        
     } else {
      if(this.updatePasswordForm.status.toLocaleLowerCase()=="valid"){
        this.UpdatePassword=true;
      }
       return null;
     }
    }else{
      this.UpdatePassword=false;
     // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });       
    }      
   }

    // To match password on confirm password input box
    matchPassword(): void { 
     var newPassword= this.updatePasswordForm.controls['newPassword'].value.length;
     var confirmPassword= this.updatePasswordForm.controls['confirmPassword'].value.length;
     if(newPassword >= 8 && confirmPassword >= 8){
      if (this.updatePasswordForm.controls['newPassword'].value !== this.updatePasswordForm.controls['confirmPassword'].value) {
        this.UpdatePassword=false;
        //this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });        
      } else {
        if(this.updatePasswordForm.status.toLocaleLowerCase()=="valid"){
          this.UpdatePassword=true;
        }
       
        return null;
      }
     }else{
      this.UpdatePassword=false;
      // this.updatePasswordForm.controls['confirmPassword'].setErrors({ MatchPassword: true });       
     }      
    }

    updatePassword(formValues){
      if (formValues != undefined) {
        this.updatePasswordVm.password = this.encryptionAlgo.set(this.reusableClass.encryptionKey, formValues.newPassword);
        this.updatePasswordVm.confirmPassword = this.encryptionAlgo.set(this.reusableClass.encryptionKey, formValues.confirmPassword);
        this.updatePasswordVm.email=encodeURIComponent(decodeURIComponent(this.updatePasswordVm.email))
        this.updatePasswordVm.token=encodeURIComponent(decodeURIComponent(this.updatePasswordVm.token))
        this.loaderService.show();
        this.commonService.updatePassword(this.updatePasswordVm).subscribe(response=>{
          if (response) {
            this.loaderService.hide();
            this.updatePasswordResponseHolder = response;
            if (this.updatePasswordResponseHolder.status == this.statusConstant.statusSuccess) {
              this.toastr.success("Password updated successfully.", '', {
                timeOut: 3000,
              });
              this.UpdatePassword=false;
              this.router.navigate(['/auth/login']);
            }
            else{
               this.UpdatePassword=false;
               this.loaderService.hide();
               this.toastr.error(this.updatePasswordResponseHolder.message+', '+"Please try later!", '', {
                timeOut: 3000,
              });
              this.updatePasswordForm.reset();
              this.UpdatePassword=false;
              // this.router.navigate(['/auth/forgotPassword']);
            }
          }
          else {
            this.loaderService.hide();
          }
        });
      }
    }

}
